import { create } from 'zustand';

/** Controls the Setup Guide modal (opened from the sidebar menu and the dashboard banner). */
interface SetupGuideState {
  open: boolean;
  openGuide: () => void;
  closeGuide: () => void;
}

export const useSetupGuideStore = create<SetupGuideState>((set) => ({
  open: false,
  openGuide: () => set({ open: true }),
  closeGuide: () => set({ open: false }),
}));
